<template>
  <div>
    <SettingsNavigation />

    <div
      class="max-w-screen-xl mx-auto sm:grid sm:grid-cols-2 sm:gap-x-6 px-6"
    >
      <AboutCard />
      <WebhooksCard />
    </div>

    <div class="max-w-screen-xl mx-auto px-6 mt-6">
      <GuideCard />
    </div>
  </div>
</template>

<script>
import AboutCard from '@components/Settings/Webhooks/AboutCard'
import GuideCard from '@components/Settings/Webhooks/GuideCard'
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import WebhooksCard from '@components/Settings/Webhooks/WebhooksCard'

export default {
  components: {
    AboutCard,
    GuideCard,
    SettingsNavigation,
    WebhooksCard
  }
}
</script>
